import { Cancel, Save } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../../api2";
import Helper from "../../../helpers";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyFormModuleAndFunction,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { ValidateSchema, ValidateSchemaUpdate } from "./validate";
import { FormNhap, FormNhapUpdate } from "./form";
import { parseDataSave, propsToInitialState } from "./models";
import { Constant } from "../../../constants/constant";

const RoutesQuanLyNhomChucNang = [
  {
    path: "",
    main: () => <QuanLyNhomChucNang />
  },
  {
    path: "add",
    main: () => <HandleQuanLyNhomChucNang />
  },
  {
    path: "edit/:id",
    main: () => <HandleQuanLyNhomChucNang />
  }
];
export default RoutesQuanLyNhomChucNang;

function QuanLyNhomChucNang() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: "",
    linhVuc: null,
    app: null
  });
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const [linhVucList, setLinhVucList] = useState([]);

  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : "";
    const page = values?.page || "";
    const appId = values?.app?.id || 0;
    return { tuKhoa, limit, anchor, appId, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
    if (isEmpty(linhVucList)) {
      new Api().GetDM_LinhVucs({}).then(data => {
        if (data.code === 200) {
          setLinhVucList(data?.data?.result?.data);
        }
      });
    }

  }, []);

  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page, appId }) => {
    new Api()
      .GetListModule({ tuKhoa, limit, anchor, appId })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => { });
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      { headerName: "Tên nhóm chức năng", field: "name", width: "300px" },
      {
        headerName: "Mã nhóm chức năng",
        field: "moduleCode",
        minWidth: 200,
        flex: 1
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteModule({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => { });
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs
        title={[{ name: "Quản trị hệ thống" }, { name: "Quản lý nhóm chức năng" }]}
      />
      <MyFormModuleAndFunction
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
        linhVucList={linhVucList}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
    </div>
  );
}

function HandleQuanLyNhomChucNang() {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const [linhVucList, setLinhVucList] = useState([]);
  const dataDanhMuc = common?.danhmucs?.data;
  const profile = common?.profile?.data;
  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetModuleById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data?.result);
          }
        })
        .catch(err => { })
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(linhVucList)) {
      new Api().GetDM_LinhVucs({}).then(data => {
        if (data.code === 200) {
          setLinhVucList(data?.data?.result?.data);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(data, linhVucList);

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={id ? ValidateSchemaUpdate : ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          {
            id ?
              <FormNhapUpdate
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
              />

              :
              <FormNhap
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
                linhVucList={linhVucList}
              />
          }

        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }
    if (id) {
      new Api()
        .UpdateModule({
          data: parseDataSave(formRef.current.values),
          id: id
        })
        .then(res => {
          if (!res || res.code !== 200) {
            ThongBao({
              status: "error",
              message: res?.message
            });
            return;
          }
          ThongBao({ status: "success", message: "Thành công" });
          navigate(-1);
        })
        .catch(err => {
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
        })
        .finally(() => { });
    } else {
      new Api()
        .AddModule({
          data: parseDataSave(formRef.current.values)
        })
        .then(res => {
          if (!res || res.code !== 200) {
            ThongBao({
              status: "error",
              message: res?.message
            });
            return;
          }
          ThongBao({ status: "success", message: "Thành công" });
          navigate(-1);
        })
        .catch(err => {
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
        })
        .finally(() => { });
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Quản trị hệ thống" },
            { name: "Quản lý nhóm chức năng", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            handleSave();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
